module.exports = __webpack_public_path__ + "media/V23.ac2422b7.mp4";